import React, { useEffect } from 'react';
import { Typography, Row, Col, Card, Space, Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './NotFoundPage.css';

const { Title, Text, Paragraph } = Typography;

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  // Set page metadata
  useEffect(() => {
    document.title = 'Page Not Found | SNS Intelligence';
    
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Page not found - SNS Intelligence');
  }, []);

  return (
    <div className="not-found-page">
      {/* Navigation */}
      <nav className="not-found-navbar">
        <div className="nav-container">
          <div
            className="nav-logo"
            role="button"
            tabIndex={0}
            onClick={() => navigate('/')}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                navigate('/');
              }
            }}
          >
            <img src="/sns-focus-logo.png" alt="SNS Intelligence" />
          </div>
        </div>
      </nav>

      <div className="not-found-container">
        <Row justify="center">
          <Col xs={24} md={20} lg={16}>
            <Card className="not-found-card">
              <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
                <Title level={1} className="not-found-title">
                  Page not found
                </Title>
                <Paragraph className="not-found-description">
                  The page you are looking for does not exist or has been moved.
                </Paragraph>
                <Button 
                  type="primary" 
                  size="large"
                  icon={<HomeOutlined />}
                  onClick={() => navigate('/')}
                >
                  Return to Homepage
                </Button>
              </Space>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default NotFoundPage;
